import { makeWebchatChatSessionsRepository } from 'modules/webchat/infra/repositories';

import LeaveWebchatUseCase from './implementations/LeaveWebchatUseCase';

let instance: LeaveWebchatUseCase | null = null;

export default function makeLeaveWebchatUseCase() {
  if (!instance) {
    instance = new LeaveWebchatUseCase(makeWebchatChatSessionsRepository());
  }

  return instance;
}
